<ds-radio-toggle
  [title]="title"
  [dataId]="dataId"
  [selected]="isSelected"
  [error]="isError"
  [editable]="isWritable"
  [editValue]="editValue"
  [displayValue]="displayValue"
  [prefix]="'$'"
  (valueChange)="valueChange.emit($event)"
  (editBlur)="valueInputFocusOut.emit($event)"
/>
